/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContainerSortimentCreateRequest } from '../../models/container-sortiment-create-request';
import { ContainerSortimentCreateResponse } from '../../models/container-sortiment-create-response';

export interface AddContainerToSortiment$Params {
      body: ContainerSortimentCreateRequest
}

export function addContainerToSortiment(http: HttpClient, rootUrl: string, params: AddContainerToSortiment$Params, context?: HttpContext): Observable<StrictHttpResponse<ContainerSortimentCreateResponse>> {
  const rb = new RequestBuilder(rootUrl, addContainerToSortiment.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContainerSortimentCreateResponse>;
    })
  );
}

addContainerToSortiment.PATH = '/sortiments/containers';
